import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { StatusCount } from '@nimmsta/ng-workflow-lib/models';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SmartwatchService {
  private http = inject(HttpClient);


  getSmartwatchStatus(): Observable<StatusCount[]> {
    return this.http.get<StatusCount[]>(`${environment.apiUrls.b2b}/api/smartwatches/count`);
  }
}
